import {IEnvironment} from '../app/0-application/types'

export const environment: IEnvironment = {
  production: false,
  domain: 'payment-validation.internal.sparbankensyd.se',
  authServiceUrl: 'https://pv.internal.sparbankensyd.se/service',
  apiUrl: 'https://pv.internal.sparbankensyd.se/api'
}